import { type MiddlewhereFilter } from '../components/filter/FilterItemManager';

export default function getDefaultFilters({
	settings,
	defaultFilters,
	userData
}: {
	settings: any;
	defaultFilters: MiddlewhereFilter[];
	userData: any;
}) {
	if (userData.user_role_external) {
		if (settings.modu_title === 'workreports')
			return [
				...defaultFilters,
				{
					filt_field: 'wore_user_assigned_uid',
					filt_clause: 'equals',
					filt_value: userData.user_uid
				}
			];

		return [
			...defaultFilters,
			{
				filt_field: `${settings.modu_short}_user_assigned_2_uid`,
				filt_clause: 'equals',
				filt_value: userData.user_uid
			}
		];
	}

	return defaultFilters;
}
